import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, NgModule } from '@angular/core';
import { NgxsModule, select } from '@ngxs/store';
import { throwError } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ResetPasswordState, ResetPasswordStateResetPassword } from './reset-password.state';
import { catchError, tap } from 'rxjs/operators';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AnimateModule,
  BasicPage,
  FormErrorHandlerService,
  HeaderComponent,
  InputValidatorDirective,
  InvalidControlScrollDirective,
  NewsletterComponent,
  ValidateMessageComponent,
} from '@pro-connect/shared';
import { ToastrService } from 'ngx-toastr';
import { NgxsFormDirective } from '@ngxs/form-plugin';
import { RouterLink } from '@angular/router';

@NgModule({
  imports: [NgxsModule.forFeature([ResetPasswordState])],
})
class ResetPasswordLazyStateModule {}

@Component({
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxsFormDirective,
    InvalidControlScrollDirective,
    AnimateModule,
    InputValidatorDirective,
    ValidateMessageComponent,
    RouterLink,
    NgOptimizedImage,
    NewsletterComponent,
    ResetPasswordLazyStateModule,
    HeaderComponent,
  ],
})
export class ResetPasswordComponent extends BasicPage {
  public override readonly loading = select(ResetPasswordState.loading);

  private readonly _formBuilder: FormBuilder = inject(FormBuilder);
  public readonly formGroup: FormGroup<{ code: FormControl<string | null> }> = this._formBuilder.group<{
    code: FormControl<string | null>;
  }>({
    code: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
  });

  constructor(
    private readonly _formErrorHandlerService: FormErrorHandlerService,
    private readonly _toastrService: ToastrService,
  ) {
    super();
  }

  get f() {
    return this.formGroup.controls;
  }

  public onResetPassword(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.invalid) {
      return;
    }
    this._store
      .dispatch(new ResetPasswordStateResetPassword())
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        catchError((error) => {
          if (error === 'timeout') {
            this._toastrService.error('Błąd przekroczenia limitu czasu żądania', 'Błąd');
          }
          this._formErrorHandlerService.catchFormError(error, this.formGroup);
          if (error?.error?.message) {
            this._toastrService.error(error.error.message, 'Błąd');
          } else {
            this._toastrService.error('Coś poszło nie tak.', 'Błąd');
          }
          return throwError(() => error);
        }),
        tap(() => {
          this._toastrService.success('Link do resetu hasła został wysłany na podany adres e-mail.', 'Sukces');
          this.formGroup.reset();
        }),
      )
      .subscribe();
  }
}
